define(function(require){
    'use strict';

    var Marionette   = require('marionette');
    var ContactModel = require('models/contacts');
    var LPTCollection = require('vendor/Backbone/LPTCollection');
    var Config = require('config/application');

    return LPTCollection.extend({
        model       : ContactModel,
        url         : Config.host + '/rest/contacts/person/',
    });

});
